export function today() {
  const date = now();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function now() {
  return new Date();
}

export function currentWeekStart() {
  const date = now();
  const day = date.getDay();
  const startOfWeek = date.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(date.getFullYear(), date.getMonth(), startOfWeek);
}

export function currentMonthStart() {
  const date = now();
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function last7Days() {
  const date = now();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
}

export function last30Days() {
  const date = now();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30);
}

export function lastYear() {
  const date = now();
  return new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
}
